let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5Q5nr")).then(() => parcelRequire('cfr2D'));